export default {
    setupAttributes(existing, newAttributes) {
        let attributes = existing;

        if(newAttributes.length) {
            for (let i = 0; i < newAttributes.length; i++) {
                if(typeof attributes[newAttributes[i].attribute.toString()] !== "undefined") {
                    attributes[newAttributes[i].attribute.toString()] += ' ' + newAttributes[i].value;
                } else {
                    attributes[newAttributes[i].attribute.toString()] = newAttributes[i].value;
                }

                attributes = Object.assign({}, attributes);
            }
        }

        return attributes;
    }
}